export enum ClaimStateType {
  Registration = 'registration',
  ClaimDetails = 'claimDetails',
  ClaimDetailsNoButtons = 'claimDetailsNoButtons',
}
